import React, { useState } from 'react'
import * as R from "ramda"
import { FaCheck } from "react-icons/fa";


const Features = ({ features, locale }) => {
  const [isFeaturesActive, setFeaturesActiveStatus] = useState(false);
  const toggleFeatures = () => setFeaturesActiveStatus(!isFeaturesActive);

  if (!!features && features[0] === "undefined") {
    return null;
  }

  const renderSplitFeatures = (splitFeatures) => {
    if (isFeaturesActive) {
      return splitFeatures;
    }
    return splitFeatures[0];
  };

  const renderFeaturesButtonText = () => {
    if (!isFeaturesActive) {
      return "See all Features"
    }
    return "See less"
  }

  let featuresArray = !!features ? features : [];
  const filteredFeatures = featuresArray.filter(feature => !!feature);
  
  if (filteredFeatures.length) {
    const mapFeatures = (features) => {
      if (!!features && !!features.length) {
        return features.map((amenity) => (
          <div className="column is-4">
            <div className="amenities-item" key={amenity}><FaCheck /> {amenity}</div>
          </div>
        ));
      }
      return null;
    };

    const mappedFeatures = mapFeatures(features);
    const splitFeatures = mappedFeatures.length > 12 ? R.splitAt(12, mappedFeatures) : [mappedFeatures];
    if (splitFeatures.length > 1) {
      return (
        <div className="full-width features-section amenities-section">
          <div className="section">
            <div className="container content section">
              <h2 className="title">FEATURES</h2>
              <div className="columns is-multiline">
                {renderSplitFeatures(splitFeatures)}
              </div>
              <button class="btn-secondary" onClick={toggleFeatures}>{renderFeaturesButtonText()}</button>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="full-width features-section amenities-section">
        <div className="section">
          <div className="container content section">
            <h2 className="title">FEATURES</h2>
            <div className="columns is-multiline">
              {mappedFeatures}
            </div>
          </div>
        </div>
      </div>
    )
  }
  return null;
}

export default Features;
